import { render, staticRenderFns } from "./formPanel.vue?vue&type=template&id=6522071d&scoped=true&"
import script from "./formPanel.vue?vue&type=script&lang=js&"
export * from "./formPanel.vue?vue&type=script&lang=js&"
import style0 from "./formPanel.vue?vue&type=style&index=0&id=6522071d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6522071d",
  null
  
)

export default component.exports